import c from "./CounterStatus.module.scss";
import { cn } from "../../lib/utils";

function CounterStatus({ value, icon, label, tooltipLabel, ...props }) {
	return (
		<div
			{...(tooltipLabel && {
				"data-tooltip-id": "tooltip_small_top",
				"data-tooltip-offset": 10,
				"data-tooltip-content": tooltipLabel,
			})}
			{...props}
			className={cn(c.counter_status, props.className)}
		>
			<div className={c.main_value}>
				{icon && <span className={icon}></span>}
				{value}
			</div>
			{label && (
				<div className={c.main_label}>
					<span className={c.label}>{label}</span>
				</div>
			)}
		</div>
	);
}

export default CounterStatus;
